<template>
	<div>
		<navbar
			@reload="reload"
			:data="item"
			:user="user"
			:isAuth="isAuth"
			:type="'show'">
		</navbar>
		<div class="row">
			<div class="col-md-12">
				<media-manager
					v-if="item"
					@reload="reloadMedia"
					:url="url"
					:public="false"
					:medias="docs"
					:user="user"
					:isAuth="isAuth"
					:dropzone="dropzoneDoc">
				</media-manager>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Navbar from './Navbar'
	import MediaManager from './../../MediaManager/layout/MediaManager.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'navbar': Navbar,
			'media-manager': MediaManager,
		},
		data () {
			return {
				item: null,
				loading: false,
				docs: null,
				dropzoneDoc: {
					accepted: this.$env.ACCEPTED_DROPZONE_DOCS,
					url: process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin',
					maxFileSizeInMB: 20,
					maxNumberOfFiles: null,
				},
				url: null,
			}
		},
		watch: {
		},
		created() {
			this.init()
		},
		computed: {
		},
		methods: {
			init() {
				this.getData()
			},
			reload() {
				this.getData()
			},
			reloadMedia() {
				this.getData()
				this.getDocs()
			},
			getData () {
				var id = this.$route.params.id
				if(id) {
					this.$http.get('admin/customers/' + id)
						.then(response => {
							this.item = response.body
							this.getDocs()
							this.dropzoneDoc.url =  process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin/customers/' + this.item.id
							this.setUrl()
						}).catch(response => {
							console.log(response)
							if(response.status == 423) {
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type,
								})
							} else {
								swal({
									title: response.statusText,
									text: response.body,
									type: 'warning',
								})
							}
						})
				}
			},
			getDocs() {
				if(this.item) {
					this.$http.get('admin/customers/' + this.item.id + '/media/docs')
					.then(response => {
						this.docs = response.body
					}).catch(response => {
						console.log(response)
					})
				}
			},
			setUrl() {
				var menu = null
				if(this.$route) {
					if(this.$route.meta) {
						if(this.$route.meta.menu) {
							menu = this.$route.meta.menu
						}
					}
				}

				if(menu) {
					if(menu == 'dashboard') {
						this.url = '/' + this.$lang.getLang() + '/' + this.$platform.slug + '/admin/customers/'  + this.item.id + '/docs/'
					} else {
						this.url = '/' + this.$lang.getLang() + '/' + this.$platform.slug + '/admin/' + menu + '/customers/'  + this.item.id + '/docs/'
					}
				} else {
					this.url = '/' + this.$lang.getLang() + '/' + this.$platform.slug + '/admin/customers/'  + this.item.id + '/docs/'
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/customers/views/Docs.vue